'use strict';

var React = require('react'),
    Page = require('../organisms/Page'),
    Container = require('../organisms/Container'),
    ScrollStateMixin = require('../mixins/ScrollStateMixin'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    UserStore = require('../stores/UserStore'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    AppContext = require('../AppContext'),
    { RouteHandler } = require('react-router');

var HomePage = React.createClass({
  mixins: [ScrollStateMixin, PureRenderMixin],

  statics: {
    willTransitionTo(transition) {
      if (!UserStore.isAuthenticated()) {
        transition.redirect('about');
      }
    }
  },

  getScrollState(scrollY) {
    return {
      isScrolled: scrollY > 96
    };
  },

  getNavigationContext() {
    const { isScrolled } = this.state;
    return [NavigationContextTypes.HOME, { isScrolled }];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    return {
      navigationContextType,
      navigationContextOptions
    };
  },

  render() {
    return (
      <AppContext {...this.getAppContext()}>
        <Page showFooter>
          <Container context='Page'>
            <RouteHandler isScrolled={this.state.isScrolled}
                          {...this.props} />
          </Container>
        </Page>
      </AppContext>
    );
  }
});

module.exports = HomePage;



/** WEBPACK FOOTER **
 ** ./pages/HomePage.jsx
 **/